export class PositionManagementInfo {
  PositionId: number
  ModuleId: number
  PositionCode: string
  PositionName: string
  PositionLevel: string = '1';
  PositionLevelName: string;
  FlagCreate: string
  FlagEdit: string
  FlagDeleteRights: string
  FlagApprove: string
  FlagAssign: string
  FlagView: string
  FlagActive: string = 'Y';
  FlagDelete: string
  CreateBy: string
  CreateDate: string
  UpdateBy: string
  UpdateDate: string
}

export class PositionLevelInfo {
  PositionLevelId: number
  PositionLevel: number
  PositionLevelName: string
  FlagActive: string = 'Y'
  FlagDelete: string
  CreateBy: string
  CreateDate: string
  UpdateBy: string
  UpdateDate: string
}
